const {
  CLIENT_PROD_HOST,
  CLIENT_STAGING_HOST,
  SERVER_STAGING_URL,
  SERVER_DEV_URL,
  SERVER_PROD_URL,
  SERVER_GOLF_PASS_DEV_URL,
  SERVER_GOLF_PASS_STAGING_URL,
  SERVER_GOLF_PASS_PROD_URL,
  CLIENT_GOLF_PASS_DEV_URL,
  CLIENT_GOLF_PASS_STAGING_URL,
  CLIENT_GOLF_PASS_PRODUCTION_URL,
} = require("../../config");

export const API_STAGING_URL = "https://fantastg.cloudxier.com";
export const API_PROD_URL = "https://fantastg.nizerteklintasbumi.com";
export const API_DEV_URL = "http://localhost:3456/";

export const IS_STAGING = window.location.host === CLIENT_STAGING_HOST;
export const IS_PRODUCTION = window.location.host === CLIENT_PROD_HOST;
export const DISABLE_FETCH = IS_STAGING || IS_PRODUCTION;

export let API_BASE_URL = "";
export let GOLF_PASS_API_BASE_URL = "";
export let GOLF_PASS_CLIENT_BASE_URL = "";

if (IS_STAGING) {
  API_BASE_URL = SERVER_STAGING_URL;
  GOLF_PASS_API_BASE_URL = SERVER_GOLF_PASS_STAGING_URL;
  GOLF_PASS_CLIENT_BASE_URL = CLIENT_GOLF_PASS_STAGING_URL;
} else if (IS_PRODUCTION) {
  API_BASE_URL = SERVER_PROD_URL;
  GOLF_PASS_API_BASE_URL = SERVER_GOLF_PASS_PROD_URL;
  GOLF_PASS_CLIENT_BASE_URL = CLIENT_GOLF_PASS_PRODUCTION_URL;
} else {
  API_BASE_URL = SERVER_DEV_URL;
  GOLF_PASS_API_BASE_URL = SERVER_GOLF_PASS_DEV_URL;
  GOLF_PASS_CLIENT_BASE_URL = CLIENT_GOLF_PASS_DEV_URL;
}
